export enum AddressType {
    Other = 0,
    Shipping = 1,
    Billing = 2,
    Technical = 3,
    Contact = 4,
    None = 5,
}